import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ThinkFinanceLogo from '../assets/ThinkFinance-Logo-removebg-preview.png'; 
import ThinkFinanceImage from '../assets/Finance - PNL.png';

const ThinkFinance = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const labelRef = useRef(null);
  const titleRef = useRef(null);
  const iconRef = useRef(null);
  const taglineRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );
    
    // Observe all animated elements
    const elementsToObserve = [
      imageRef.current,
      labelRef.current,
      titleRef.current,
      iconRef.current,
      taglineRef.current,
      descriptionRef.current,
      buttonRef.current
    ];

    elementsToObserve.forEach((element) => {
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  return (
    <section id="thinkfinance" className="think-finance" ref={sectionRef}>
      <div className="container think-finance-container">
        <div className="section-content">
  <div className="header-container">
    
    <div className="logo-with-underline">
      <div
          className="product-title inline slide-in-left" 
          ref={titleRef}
          style={{ animationDelay: '0.1s' }}
          >
            <div className="tf-logo-with-underline">
          <img  className="think-finance-title-product"
          src={ThinkFinanceLogo}
          alt="ThinkFinance"
        />
        </div>
        </div>
</div>
  </div>
  
  <h2 
    className="product-tagline fade-in-up" 
    ref={taglineRef}
    style={{ animationDelay: '0.6s' }}
  >
    Effortlessly unravel your company's financial health with just a few clicks—no accountants required!
  </h2>
  
  <p 
    className="product-description fade-in-up" 
    ref={descriptionRef}
    style={{ animationDelay: '0.8s' }}
  >
    Experience instant access to comprehensive financial reporting across different
    parameters and metrics. ThinkFinance converts complex data into actionable
    performance tracking insights with easy-to-interpret graphs, offering you a 360° view of your
    company's standing.
  </p>
  
  <button 
    className="explore-button slide-in-up" 
    onClick={() => handleNavigate('/thinkfinance')}
    ref={buttonRef}
    style={{ animationDelay: '1.0s' }}
  >
    Explore Financial Analytics
  </button>
</div>
        <div 
          className="section-image slide-in-right" 
          ref={imageRef}
          style={{ animationDelay: '0.3s' }}
        >
          <img src={ThinkFinanceImage} alt="ThinkFinance" className="think-finance-image"/>
        </div>
      </div>
    </section>
  );
};

export default ThinkFinance;